export default "__VITE_ASSET__DmXvCCxi__"